import React from 'react';
import { Question } from '../../hooks/useQuiz';

interface QuizAnswersProps {
  question: Question;
  selectedAnswer: string | null;
  onAnswerSelect: (answerId: string) => void;
}

export const QuizAnswers: React.FC<QuizAnswersProps> = ({
  question,
  selectedAnswer,
  onAnswerSelect
}) => {
  return (
    <div className="px-2 sm:px-4 lg:px-6 py-2 sm:py-4 bg-transparent">
      {/* Opzioni risposta */}
      <div className="space-y-2 sm:space-y-3 bg-transparent">
        {question.answerOptions
          .sort((a, b) => a.order - b.order)
          .map((option) => (
            <button
              key={option.id}
              onClick={() => onAnswerSelect(option.id)}
              className={`w-full p-3 sm:p-4 text-left rounded-xl transition-all duration-200 shadow-md ${
                selectedAnswer === option.id
                  ? 'bg-primary-50 text-primary-900 shadow-lg'
                  : 'bg-white hover:bg-gray-50 hover:shadow-lg'
              }`}
            >
              <div className="flex items-start space-x-2 sm:space-x-3">
                {/* Cerchio sempre perfetto */}
                <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center transition-colors duration-200 flex-shrink-0 ${
                  selectedAnswer === option.id
                    ? 'border-primary-500 bg-primary-500'
                    : 'border-gray-300'
                }`}>
                  {selectedAnswer === option.id && (
                    <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" />
                  )}
                </div>
                {/* Testo che può andare a capo */}
                <span className="quiz-answer-text text-gray-900 font-medium leading-relaxed flex-1 break-words whitespace-normal">
                  {option.text}
                </span>
              </div>
            </button>
          ))}
      </div>
    </div>
  );
};
